import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import { getExpense, deleteExpense } from "../../store/slices/expense";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";

export default function Expense() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { expenseList = [] } = useSelector((state) => state.expense);

  useEffect(() => {
    dispatch(getExpense());
  }, [dispatch]);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteExpense(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const totalPages = Math.ceil(expenseList.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentExpense = expenseList.slice(indexOfFirstItem, indexOfLastItem);

  const changePage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel")}
          >
            Expense
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/hotel/addexpense")}
        >
          + Add Expense
        </button>
      </div>
      <Container fluid>
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Title</th>
                    <th className="text-center">Expense Number</th>
                    <th className="text-center">Payment Mode</th>
                    <th className="text-center">Amount</th>
                    <th className="text-center">Paid By</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {expenseList?.length > 0 ? (
                    currentExpense.map((expense, index) => (
                      <tr key={expense._id}>
                        <td className="text-center">
                          {indexOfFirstItem + index + 1}
                        </td>

                        <td className="text-center">{expense.title}</td>

                        <td className="text-center">{expense.expenseNumber}</td>

                        <td className="text-center text-capitalize">
                          {expense.paymentMode}
                        </td>

                        <td className="text-center text-capitalize">
                          <BiRupee size={15} />
                          {expense.amount}
                        </td>

                        <td className="text-center">
                          {expense.paidBy?.name || "N/A"}
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            {/* Edit */}
                            <button
                              onClick={() =>
                                navigate(`/hotel/editexpense/${expense._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            {/* Delete */}
                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(expense._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted py-4">
                        No Expense Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Prev
                </Button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    variant={
                      currentPage === i + 1 ? "primary" : "outline-secondary"
                    }
                    onClick={() => changePage(i + 1)}
                    className={`button-between ${currentPage === i + 1 ? "active-page" : ""
                      }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
